import React from 'react';
import './Additional.css';

import CurvedBottom from '../../../components/CurvedBottom/CurvedBottom';
import Icon from '../../../components/Icon/Icon';

const additional = ( props ) => (
	<section id="Additional" className="bg-color-2 hasCurve">
		<h2>Additional Benefits</h2>
		
		<div className="additional-section additional-insurance">
			<div>
				<p>
					{ 'We have a short-term and long-term disability program for employees at no cost. Short-term disability pays 60% of your salary (up to $1,000) for up to 13 weeks if you are unable to work. After that, long-term disability will take over coverage. For more information on short-term and long-term disability, please contact ' }
					<a href="mailto:HR@idsi.com">
					Karen Marrero
					</a>
					.
				</p>
				<p>
					We also have long-term care insurance, which is separate from your disability coverage. This is a 3-year benefit that provides assistance if you can't care for yourself due to injury or illness. You may also purchase additional supplemental coverage.
				</p>
				<p>
					We offer basic life insurance at no cost for eligible employees. You may also purchase additional supplemental life insurance.
				</p>
			</div>
			<Icon icon="benefits.germs" title="Additional Insurance" />
		</div>
		
		<div className="additional-section additional-learning">
			<Icon icon="benefits.school" title="Education" />
			<p>
				IDSI encourages lifelong learning! If you're interested in educational opportunities to help you develop as an employee, speak with your supervisor about what options are available.
			</p>
		</div>
		
		<CurvedBottom />
	</section>
);

export default additional;



// WEBPACK FOOTER //
// ./src/pages/Benefits/Additional/Additional.js